import React, { useState } from 'react'
import MySubscription from './MySubscription/MySubscription'
import Feedback from './Feedback/Feedback'
// import EmergencyPincode from './EmergencyPincode/EmergencyPincode'
import ChangeEmergencyPincode from './EmergencyPincode/ChangeEmergencyPincode'
// import ForgotEmergencyPincode from './EmergencyPincode/ForgotEmergencyPincode'
import AccountSettings from './AccountSettings/AccountSettings'
import UninstallTheApp from './UninstallTheApp/UninstallTheApp'
import useLangTranslation from '../../../customHooks/languageProvider';
import { useSelector } from 'react-redux';
import useSubscription from '../../../customHooks/subscriptionProvider';

const Settings = () => {
    const { isAdditionalParent } = useSelector(({ auth }) => auth);
    const [activeTab, setActiveTab] = useState(isAdditionalParent ? 'SETTING_ACCOUNT_SETTINGS' : 'MY_SUBSCRIPTION');
    const { getLangTranslation } = useLangTranslation();

    let btnOptions = [
        { name: 'MY_SUBSCRIPTION', text: 'My Subscription' },
        { name: 'SETTINGS_EMERGENCY_PIN_CODE', text: 'Emergency pin code' },
        { name: 'SETTING_FEEDBACK_RATINGS', text: 'Feedback & Rating' },
        { name: 'SETTING_ACCOUNT_SETTINGS', text: 'Account Settings' },
        { name: 'UNINSTALL_APP_CHILD_DEVICE', text: "Uninstall the app from child's device" },
    ];

    if (isAdditionalParent) {
        btnOptions.shift();
        btnOptions.shift();
        btnOptions.shift();
    }

    const [btns, setBtns] = useState(btnOptions)

    const {
        countryList,
        timezoneIdList
    } = useSelector(({ misc }) => misc);

    const { checkSubsciption } = useSubscription();

    return (
        <>
            {/* <nav>
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button 
                        className="nav-link" 
                        id="mySubscriptionTab" 
                        data-bs-toggle="tab" 
                        data-bs-target="#mySubscription" 
                        type="button" 
                        role="tab" 
                        aria-controls="mySubscription" 
                        aria-selected="false"
                    >
                        My subscription
                    </button>
                    <button 
                        className="nav-link active" 
                        id="emergencyPinTab" 
                        data-bs-toggle="tab" 
                        data-bs-target="#emergencyPin" 
                        type="button" 
                        role="tab" 
                        aria-controls="emergencyPin" 
                        aria-selected="true"
                    >
                        Emergency PIN CODE
                    </button>
                    <button className="nav-link" id="feedbackTab" data-bs-toggle="tab" data-bs-target="#feedback" type="button" role="tab" aria-controls="feedback" aria-selected="false">Feedback & rating</button>
                    <button className="nav-link" id="accountSettingsTab" data-bs-toggle="tab" data-bs-target="#accountSettings" type="button" role="tab" aria-controls="accountSettings" aria-selected="false">Account settings</button>
                    <button className="nav-link" id="uninstallTheAppTab" data-bs-toggle="tab" data-bs-target="#uninstallTheApp" type="button" role="tab" aria-controls="uninstallTheApp" aria-selected="false">Uninstall the app from child's device</button>
                </div>
            </nav> */}
            {/* <div className='card border-0'>
                <div className='card-body'>
                    <div className="tab-content" id="nav-tabContent">
                        <div className="tab-pane fade show active" id="mySubscription" role="tabpanel" aria-labelledby="mySubscriptionTab">
                            <MySubscription />
                        </div>
                        <div className="tab-pane fade" id="emergencyPin" role="tabpanel" aria-labelledby="emergencyPinTab">
                            <EmergencyPincode />
                        </div>
                        <div className="tab-pane fade" id="feedback" role="tabpanel" aria-labelledby="feedbackTab">
                            <Feedback />
                        </div>
                        <div className="tab-pane fade" id="accountSettings" role="tabpanel" aria-labelledby="accountSettingsTab">
                            <AccountSettings />
                        </div>
                        <div className="tab-pane fade" id="uninstallTheApp" role="tabpanel" aria-labelledby="uninstallTheAppTab">
                            <UninstallTheApp />
                        </div>
                    </div>
                </div>
            </div> */}
            {/* <nav> */}
            <div className="nav nav-tabs">
                {btns?.map((item, index) => {
                    return (
                        <button
                            className={`nav-link ${item?.name === activeTab ? 'active' : ''}`}
                            id={item?.name}
                            type="button"
                            role="tab"
                            name={item?.name}
                            onClick={() => setActiveTab(item?.name)}
                            key={item?.name}
                        >
                            {
                                getLangTranslation(item?.name, item?.text)
                            }
                        </button>
                    )
                })}
            </div>
            {/* </nav> */}
            <div className='card border-0'>
                <div className='card-body'>
                    {/* <div className="tab-content" id="nav-tabContent"> */}
                    {
                        activeTab === 'MY_SUBSCRIPTION' && (
                            <div className="tab-pane fade show active" id="mySubscription">
                                <MySubscription
                                    getLangTranslation={getLangTranslation}
                                    checkSubsciption={checkSubsciption}
                                />
                            </div>
                        )
                    }

                    {
                        activeTab === 'SETTINGS_EMERGENCY_PIN_CODE' && (
                            <div className="tab-pane fade show active" id="emergency_pincode">
                                {/* <EmergencyPincode
                                    getLangTranslation={getLangTranslation}
                                    checkSubsciption={checkSubsciption}
                                /> */}
                                <ChangeEmergencyPincode 
                                    getLangTranslation={getLangTranslation}
                                />
                            </div>
                        )
                    }

                    {
                        activeTab === 'SETTING_FEEDBACK_RATINGS' && (
                            <div className="tab-pane fade show active" id="feedback">
                                <Feedback
                                    getLangTranslation={getLangTranslation}
                                    checkSubsciption={checkSubsciption}
                                />
                            </div>
                        )
                    }

                    {
                        activeTab === 'SETTING_ACCOUNT_SETTINGS' && (
                            <div className="tab-pane fade show active" id="accountSettings">
                                <AccountSettings
                                    countryList={countryList}
                                    timezoneIdList={timezoneIdList}
                                    getLangTranslation={getLangTranslation}
                                    checkSubsciption={checkSubsciption}
                                />
                            </div>
                        )
                    }

                    {
                        activeTab === 'UNINSTALL_APP_CHILD_DEVICE' && (
                            <div className="tab-pane fade show active" id="uninstallTheApp">
                                <UninstallTheApp
                                    getLangTranslation={getLangTranslation}
                                />
                            </div>
                        )
                    }

                    {/* </div> */}
                </div>
            </div>
        </>
    )
}

export default Settings